const tours = {
  tour: "旅游", // translated
  tours: "旅游", // translated
  addOn: "添加在", // translated
  addOns: "附加组件", // translated
  availableEscapes: "可用的逃生方式", // translated
  availableExperiences: "可用的体验", // translated
  getRequest: "获取请求", // translated
  sendRequest: "发送请求", // translated
  selectRoom: "选择房间", // translated
};

export default tours;
